/**
 * DEV (deployed) environment.
 * Frontend: https://onegate-dev.ringoffice.com
 * API: same host via /api reverse proxy.
 *
 * This is the shared dev server — not for `ng serve` on your laptop.
 * For local laptop development use the default `environment.ts`.
 */
export const environment = {
  envName: 'dev' as 'local' | 'dev' | 'uat' | 'production',
  production: false,
  apiBaseUrl: 'https://onegate-dev.ringoffice.com/api',
  frontendOrigin: 'https://onegate-dev.ringoffice.com',
  websiteUrl: 'https://demo-site.ringoffice.com',
  licensePortalUrl: 'https://3cxlm-dev.ringoffice.com/my-licenses',
  enableDebugLogs: true,
  sentryDsn: '',
  appVersion: '1.0.0-dev',
  // USA Browser — Neko remote browser served under /usabrowser/ on the same
  // Ohio EC2 host, so any page opened inside it exits from a US IP.
  // The ?usr/?pwd params auto-login to the shared Neko session (no prompt).
  // This is a shared internal access credential, not a user secret; WebRTC is
  // additionally IP-locked in the EC2 security group.
  usaBrowserUrl: 'https://onegate-dev.ringoffice.com/usabrowser/?usr=onegate&pwd=12cdbd4e2211f9b780f5',
};
